import IndexModel from "@/service/v1/elastic/IndexModel";
 
class LogAcessoElasticService extends IndexModel {
      
    constructor() {
        super();
        this.url = this.url + '/LogAcessoElastic';
    }
 
    public getApiUrl() {
        return this.getAxios().defaults.baseURL + this.url;
    }

    
    public getTipo( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetTipo'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
    
    
    public sincronizar( params ) : Promise<any>{   
        return  new Promise((resolve, reject) => {  
            this.getAxios().get( this.url + `/SyncBancoWithElastic?${params}` )
            .then(response => {  
                resolve( response.data);  
            })
            .catch(error => {   
                console.log(error);
                reject(error.response);
            }) 
        });  
    }


    
    public sincronizarPorId( id ) : Promise<any>{   
        return  new Promise((resolve, reject) => {  
            this.getAxios().get( this.url + `/SyncBancoWithElastic/${id}` )
            .then(response => {  
                resolve( response.data);  
            })
            .catch(error => {   
                console.log(error);
                reject(error.response);
            }) 
        });  
    }
    
    
    public getRelatorio( params ) : Promise<any>{   
        return  new Promise((resolve, reject) => {  
            this.getAxios().get( this.url + `/Relatorio?${params}` )
            .then(response => {  
                resolve( response.data);  
            })
            .catch(error => {   
                console.log(error);
                reject(error.response);
            }) 
        });  
    }
 
      
}
  
export default LogAcessoElasticService;

